import { render, staticRenderFns } from "./SendEmailForgotPassword.vue?vue&type=template&id=e5e5b8b2&"
import script from "./SendEmailForgotPassword.vue?vue&type=script&lang=js&"
export * from "./SendEmailForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports